import { encryptBy } from '../lib/util/encryption';
import "@/assets/style/page/index.scss";
layui.use(['form', 'miniPage', 'baseApi'], function() {
  let form = layui.form,
    baseApi = layui.baseApi,
    layer = layui.layer,
    miniPage = layui.miniPage;
  let codeNum = ""
  $(document).on('keydown.login', function(e) {
    if (e.keyCode == 13 || e.code == 'Enter' || e.key == 'Enter') {
      $("#loginSubmitBut").click();
    }
  });

  // 进行登录操作
  form.on('submit(login)', function(data) {
    data = data.field;
    data.password = $.base64.btoa(data.password);
    // data.password = encryptBy(data.password);
    data = $.extend(data, {
      clientId: 'xh',
      grant_type: 'password',
    });
    if (data.username == '') {
      layer.msg('用户名不能为空');
      return false;
    }
    if (data.password == '') {
      layer.msg('密码不能为空');
      return false;
    }
    if (data.verCode == '') {
      layer.msg('验证码不能为空');
      return false;
    }
    if (!(/^[a-zA-Z0-9]+$/.test(data.username))) {
      layer.msg("用户名只能输入数字和字母");
      return false;
    }
    if (!(/^[a-zA-Z0-9]+$/.test(data.verCode))) {
      layer.msg("验证码只能输入数字和字母");
      return false;
    }
    data['codeId'] = codeNum;
    data.username = encryptBy(data.username);

    const xhr = new XMLHttpRequest();
    xhr.open("POST", `${location.protocol}//${location.host}/hospital/uaa/oauth/login`, true);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          const res = xhr.responseText ? JSON.parse(xhr.responseText) : {};
          if (res.code === 200) {
            Cookies.set('Authorization', res.data.accessToken);
            window.location = './home.html';
          } else {
            layer.msg(res.message || "登录失败请重试");
            getCodeImg();
          }
        } else {
          layer.msg("登录失败请重试");
          getCodeImg();
        }
      }
    }
    xhr.send(JSON.stringify(data));
    return false;
  });

  function createCaptcha(text) {
    let wrapDom = document.querySelector("#captcha-image-container-section");
    wrapDom.innerHTML = "";
    if (wrapDom) {
      if (text.indexOf("data") > -1 && text.indexOf("base64") > -1) {
        // 是base64
        let imgDom = document.createElement("img");
        imgDom.setAttribute("alt", "验证码");
        imgDom.setAttribute("id", "captchaPic");
        imgDom.setAttribute("src", text);
        imgDom.setAttribute("style", "width: 140px; height: 37px;");
        wrapDom.appendChild(imgDom);
      } else {
        // 返回的是数字
        let captchaCanvas = document.createElement("canvas");
        captchaCanvas.setAttribute("id", "login-page-captcha-img-id");
        captchaCanvas.setAttribute("width", "140");
        captchaCanvas.setAttribute("height", "37");
        wrapDom.appendChild(captchaCanvas);
        let captchaCtx = captchaCanvas.getContext("2d");
        captchaCtx.fillStyle = "rgb(200, 200, 200)"; //设置背景色为浅灰色
        captchaCtx.fillRect(0, 0, captchaCanvas.width, captchaCanvas.height); //填充整个画布
        for (let i = 0; i < 10; i++) { //循环绘制10条干扰线
          captchaCtx.strokeStyle = "rgb(" + Math.floor(Math.random() * 256) + "," + Math.floor(Math.random() * 256) + "," + Math.floor(Math.random() * 256) + ")"; //设置随机的线条颜色
          captchaCtx.beginPath(); //开始绘制路径
          captchaCtx.moveTo(Math.random() * captchaCanvas.width, Math.random() * captchaCanvas.height); //移动到随机的起点
          captchaCtx.lineTo(Math.random() * captchaCanvas.width, Math.random() * captchaCanvas.height); //画一条直线到随机的终点
          captchaCtx.stroke(); //绘制路径
        }
        let code = text; //初始化验证码字符串
        let textFontSize = 30;
        captchaCtx.font = `${textFontSize}px Arial`; //设置字体大小和样式
        captchaCtx.fillStyle = "rgb(0, 0, 0)"; //设置文字颜色为黑色
        for (let i = 0; i < code.length; i++) { //循环绘制每个字符
          let gap = captchaCanvas.width / (text.length - 1) - 20;
          let x = 20 + i * gap; //计算字符的横坐标
          let y = captchaCanvas.height / 2 / textFontSize + textFontSize; //计算字符的纵坐标
          let angle = Math.random() * Math.PI / 6 - Math.PI / 12; //计算字符的旋转角度，范围为-15°到15°之间
          captchaCtx.translate(x, y); //将坐标系原点移动到字符的位置
          captchaCtx.rotate(angle); //将坐标系旋转指定的角度
          captchaCtx.fillText(code[i], 0, 0); //在原点处绘制字符
          captchaCtx.rotate(-angle); //将坐标系恢复原来的角度
          captchaCtx.translate(-x, -y); //将坐标系原点恢复原来的位置
        }
      }
    }
  }

  //验证码
  $('.captcha-img').on('click',function(){
    getCodeImg()
  })
  getCodeImg()
  //获取验证码图片信息
  function getCodeImg(){
    let code = '' + (parseInt(Math.random()*1000000)+1000000);
    code = code.substring(1, 7);
    let date = Date.now();
    codeNum = code + date;
    let xhr = new XMLHttpRequest();
    xhr.open("GET", `${location.protocol}//${location.host}/hospital/uaa/oauth/getCaptcha?userName=${codeNum}`, true);
    xhr.responseType = "text";
    xhr.onload = function() {
      createCaptcha(String(this.responseText));
    }
    xhr.send();
  }
  // 忘记密码
  $('#forget').on('click', function() {
    baseApi.offsetOpen(
      '忘记密码', 'page/init/reset1.html', '.admin-login-background', 50, 30, -10, -30);
  });

});
